import { sanitizeExportBasename } from '../theme';
import {
  addBrandedHeader,
  applyAutoColumnWidths,
  applyTableAutofilter,
  buildExportSubtitle,
  createStyledWorkbook,
  downloadWorkbook,
  getBodyStyle,
  getHeaderStyle,
} from './helpers';

export async function exportResponsesExcel({
  rows,
  columnHeaders,
  invitationName,
  invitationId,
  suffix = '',
}) {
  const headers = ['ID risposta', ...columnHeaders, 'Data risposta'];
  const { workbook, worksheet } = await createStyledWorkbook('Risposte');
  const dataStartRow = await addBrandedHeader(worksheet, workbook, {
    title: invitationName ? `Risposte — ${invitationName}` : 'Risposte invito',
    subtitle: buildExportSubtitle(`${rows.length} risposte`),
    totalColumns: headers.length,
  });

  const headerRow = dataStartRow;
  headers.forEach((header, index) => {
    const cell = worksheet.getCell(headerRow, index + 1);
    cell.value = header;
    cell.style = getHeaderStyle();
  });
  worksheet.getRow(headerRow).height = 22;

  rows.forEach((row, rowIndex) => {
    const excelRow = headerRow + 1 + rowIndex;
    const isStripe = rowIndex % 2 === 1;
    headers.forEach((header, colIndex) => {
      const cell = worksheet.getCell(excelRow, colIndex + 1);
      cell.value = row[header] ?? '—';
      cell.style = getBodyStyle(isStripe);
    });
  });

  applyAutoColumnWidths(worksheet, {
    fromRow: headerRow,
    fromCol: 1,
    toCol: headers.length,
  });
  applyTableAutofilter(worksheet, headerRow, 1, headers.length);

  const fallbackName = invitationId || 'invito';
  const sanitizedTitle = sanitizeExportBasename(invitationName, fallbackName);
  await downloadWorkbook(workbook, `risposte_${sanitizedTitle}${suffix}.xlsx`);
}
